// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environmentName: 'QA',
  apiUrl: ''

};
// export const BILL_TYPE_BASE_URL = {
//   Service: {
//     CompCode: '',
//     URL: ''
//   },
//   Utility: {
//     CompCode: '',
//     URL: ''
//   },
//   IUS: {
//     CompCode: '',
//     URL: ''
//   }
// }

//UAT
// export const BASE_URL ="http://172.19.20.77:93/api/v1.0/"

//NOVIGO SERVER 
// export const BASE_URL = "http://88.99.160.11:93/api/v1.0/"

//LOCALHOST
// export const BASE_URL = "http://localhost:55444/api/v1.0/"
export const BASE_URL = ""




/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
